"use client";

import { BrandLogoImg } from "@/app/(dashboard)/_components/shared/brand-logo-img";
import { orgLogoAlt, orgLogoTitle } from "@/lib/marketing-seo";
import { useTranslations } from "next-intl";
import type { ReactElement } from "react";
import type { PortalLoginBranding } from "./portal-login-screen";

export function PortalBrandLockup({
  branding,
  accent,
}: {
  readonly branding: PortalLoginBranding;
  readonly accent: string;
}): ReactElement | null {
  const t = useTranslations("public.portalLoginScreen");
  const productName: string = branding.org_name ?? t("kundenportal");
  if (branding.logo_url) {
    return (
      <BrandLogoImg
        src={branding.logo_url}
        alt={orgLogoAlt(productName)}
        title={orgLogoTitle(productName, t("orgLogoTitleSuffix"))}
        className="block h-14 w-auto max-w-[220px] object-contain"
      />
    );
  }
  if (branding.org_name) {
    return (
      <div
        style={{
          fontSize: 20,
          fontWeight: 700,
          letterSpacing: "-0.01em",
          color: accent,
        }}
      >
        {branding.org_name}
      </div>
    );
  }
  return null;
}
